export default __webpack_public_path__ + "static/media/do-1.841e8a5f.jpg";